import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { configurationsApi } from './configurations.api';
import { configurationKeys } from './configurations.queries';
import type { UpdateAppSettingsRequest } from '../types';

export function useUpdateAppSettingsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateAppSettingsRequest) =>
      configurationsApi.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: configurationKeys.all });
      toast.success('Settings updated successfully.');
    }
  });
}
